/**
 * WebSocket连接管理工具
 * 用于接收OA系统的流程通知消息
 */
import { getStorage } from '@/storage'

class WebSocketManager {
  constructor() {
    // WebSocket连接相关
    this.ws = null                          // WebSocket连接实例
    this.reconnectTimer = null              // 重连定时器
    this.heartbeatTimer = null              // 心跳定时器
    this.reconnectAttempts = 0              // 当前重连尝试次数
    this.maxReconnectAttempts = 5           // 最大重连尝试次数
    this.reconnectInterval = 3000           // 重连间隔时间(毫秒)
    this.heartbeatInterval = 30000          // 心跳间隔时间(毫秒)
    this.isConnected = false                // 连接状态标识
    this.messageHandlers = []               // 消息处理器数组

    // 标题滚动相关
    this.originalTitle = document.title     // 页面原始标题
    this.titleTimer = null                  // 标题滚动定时器
    this.isScrolling = false                // 标题是否正在滚动
    this.scrollIndex = 0                    // 滚动字符索引位置
    this.currentMessage = ''                // 当前滚动显示的消息内容

    // 页面可见性检测
    this.isPageVisible = !document.hidden  // 页面是否可见(用于控制标题滚动)
    this.bindVisibilityChange()             // 绑定页面可见性变化事件
  }

  /**
   * 连接WebSocket
   */
  connect() {
    try {
      const employeeId = getStorage('userid')
      if (!employeeId) {
        console.warn('未找到用户ID，无法连接WebSocket')
        return
      }

      // 根据环境选择WebSocket地址
      // const env = process.env.NODE_ENV
      // const baseHost = process.env.VUE_APP_BASE_HOST || ''
      // console.log(window.location.href,'hrefhrefhref')
      // console.log('当前环境:', env, '基础域名:', baseHost)

      // 默认使用开发环境地址
      let isDev_test = window.location.hostname.includes('localhost') || window.location.hostname.includes('jszhr.test')
      let wsUrl = 'ws://192.168.10.30:2346'

      if (isDev_test) {
        wsUrl = 'ws://192.168.10.30:2346'
      } else {
        wsUrl = 'wss://apioany.jszhr.com/socket'
        // wsUrl = 'ws://113.44.11.109:2346'
      }

      this.ws = new WebSocket(wsUrl)

      this.ws.onopen = () => {
        console.log('WebSocket连接成功')
        this.isConnected = true
        this.reconnectAttempts = 0

        // 发送连接信息
        const connectMsg = {
          type: 2,
          employee_id: parseInt(employeeId),
          device_type: 2
        }
        this.send(connectMsg)

        // 开始心跳
        this.startHeartbeat()
      }

      this.ws.onmessage = (event) => {
        try {
          console.log('收到WebSocket消息:event', event)
          console.log('收到WebSocket原始数据:', event.data)

          // 解析消息数据
          //判断是否是json字符串
          function isJSONString(str) {
            try {
              JSON.parse(str);
              return true;
            } catch (e) {
              return false;
            }
          }
          const data = isJSONString(event.data) ? JSON.parse(event.data) : event.data;
          console.log('解析后的消息:', data)

          this.handleMessage(data)
        } catch (error) {
          console.error('解析WebSocket消息失败:', error)
          // 如果解析失败，传递原始字符串数据
          this.handleMessage(event.data)
        }
      }

      this.ws.onclose = () => {
        console.log('WebSocket连接关闭')
        this.isConnected = false
        this.stopHeartbeat()
        this.reconnect()
      }

      this.ws.onerror = (error) => {
        console.error('WebSocket连接错误:', error)
        this.isConnected = false
      }

    } catch (error) {
      console.error('创建WebSocket连接失败:', error)
      this.reconnect()
    }
  }

  /**
   * 发送消息
   */
  send(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(message))
    }
  }

  /**
   * 处理接收到的消息
   */
  handleMessage(data) {
    // 通知所有消息处理器
    this.messageHandlers.forEach(handler => {
      try {
        handler(data)
      } catch (error) {
        console.error('消息处理器执行失败:', error)
      }
    })
    console.log('收到WebSocket消息:', data)
    // 处理标题滚动
    if (data.type && data.msg) {
      let message = ''
      // 根据消息类型设置不同的提示文本
      if (data.type) {
        message = data.msg
      } else {
        // 使用服务器返回的消息内容
        message = data.msg
      }
      // 只有当页面不可见时才滚动标题
      if (!this.isPageVisible) {
        this.startTitleScroll(message)
      }
    }
  }

  /**
   * 开始标题滚动
   */
  startTitleScroll(message) {
    if (this.isScrolling) {
      return
    }

    this.isScrolling = true
    this.currentMessage = message
    this.scrollIndex = 0

    // 清除之前的定时器
    if (this.titleTimer) {
      clearInterval(this.titleTimer)
    }

    // 开始滚动动画
    this.titleTimer = setInterval(() => {
      const displayText = this.currentMessage + ' - '
      const scrollText = displayText.substring(this.scrollIndex) + displayText.substring(0, this.scrollIndex)
      console.log(scrollText, 'scrollText')
      console.log(scrollText.substring(0, 20), 'scrollText.substring(0, 20)')
      document.title = scrollText.substring(0, 20) // 限制标题长度
      this.scrollIndex++
      if (this.scrollIndex >= displayText.length) {
        this.scrollIndex = 0
      }
    }, 100)
  }

  /**
   * 停止标题滚动
   */
  stopTitleScroll() {
    if (this.titleTimer) {
      clearInterval(this.titleTimer)
      this.titleTimer = null
    }
    this.isScrolling = false
    this.scrollIndex = 0
    document.title = this.originalTitle
  }

  /**
   * 绑定页面可见性变化事件
   */
  bindVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      this.isPageVisible = !document.hidden

      if (this.isPageVisible) {
        // 页面变为可见时，停止标题滚动
        this.stopTitleScroll()
      }
    })

    // 监听窗口焦点事件
    window.addEventListener('focus', () => {
      this.isPageVisible = true
      this.stopTitleScroll()
    })

    window.addEventListener('blur', () => {
      this.isPageVisible = false
    })
  }

  /**
   * 开始心跳
   */
  startHeartbeat() {
    this.heartbeatTimer = setInterval(() => {
      if (this.isConnected) {
        this.send({ type: 'ping' })
      }
    }, this.heartbeatInterval)
  }

  /**
   * 停止心跳
   */
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  /**
   * 重连
   */
  reconnect() {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error('WebSocket重连次数超过限制，停止重连')
      return
    }

    this.reconnectAttempts++
    console.log(`WebSocket重连中... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`)

    this.reconnectTimer = setTimeout(() => {
      this.connect()
    }, this.reconnectInterval)
  }

  /**
   * 添加消息处理器
   */
  addMessageHandler(handler) {
    if (typeof handler === 'function') {
      this.messageHandlers.push(handler)
    }
  }

  /**
   * 移除消息处理器
   */
  removeMessageHandler(handler) {
    const index = this.messageHandlers.indexOf(handler)
    if (index > -1) {
      this.messageHandlers.splice(index, 1)
    }
  }

  /**
   * 断开连接
   */
  disconnect() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }

    this.stopHeartbeat()
    this.stopTitleScroll()

    if (this.ws) {
      this.ws.close()
      this.ws = null
    }

    this.isConnected = false
    this.messageHandlers = []
  }

  /**
   * 获取连接状态
   */
  getConnectionState() {
    return {
      isConnected: this.isConnected,
      reconnectAttempts: this.reconnectAttempts,
      isScrolling: this.isScrolling
    }
  }
}

// 创建全局WebSocket管理器实例
const wsManager = new WebSocketManager()

export default wsManager